import React, { createContext, useState, useContext, useEffect } from 'react';
import customerService from '../services/customerService';
import { useAuth } from './AuthContext';

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
    const [customer, setCustomer] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { token, role } = useAuth();

    // Tutors and Parents don't need customer settings data
    const needsCustomerData = role && role !== 'TU' && role !== 'PA';

    useEffect(() => {
        const fetchCustomerData = async () => {
            if (token && needsCustomerData) {
                try {
                    const data = await customerService.getCustomerData();
                    setCustomer(data);
                } catch (error) {
                    setCustomer(null); // Reset on error
                } finally {
                    setIsLoading(false);
                }
            } else {
                setCustomer(null); // No token or not needed
                setIsLoading(false);
            }
        };

        fetchCustomerData();
    }, [token, needsCustomerData]); // Refetch when token or role changes

    // Effect to update the favicon dynamically
    useEffect(() => {
        const favicon = document.getElementById('favicon');
        if (favicon) {
            if (customer && customer.logo_url) {
                favicon.href = customer.logo_url;
            } else {
                favicon.href = '/logo192.png'; // Default icon
            }
        }
    }, [customer]);

    const value = {
        customer,
        isLoading,
    };

    return <CustomerContext.Provider value={value}>{children}</CustomerContext.Provider>;
};

export const useCustomer = () => {
    return useContext(CustomerContext);
};
